import { FC } from 'react';

import { useCoworkingOperatorPhoneSelector } from '../../hooks/selectors/coworking/useCoworkingOperatorPhoneSelector';
import { emptyCalledFunction } from '../../utils/emptyCalledFunction';
import { ShowPhoneButton } from '../ShowPhoneButton';

import { IShowCoworkingOperatorPhoneButtonProps } from './types';

export const ShowCoworkingOperatorPhoneButton: FC<IShowCoworkingOperatorPhoneButtonProps> = props => {
  const { onClick = emptyCalledFunction } = props;

  const coworkingOperatorPhone = useCoworkingOperatorPhoneSelector();

  return <ShowPhoneButton hideButtonIfPhoneEmpty phone={coworkingOperatorPhone} onClick={onClick} />;
};

ShowCoworkingOperatorPhoneButton.displayName = 'ShowCoworkingOperatorPhoneButton';
